/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { isLanguageSupported } from '@airasia-rn/ui/localization';

const FALLBACK_HOTEL_LANGUAGE_ID = 'en-gb';

/**
 * Maps a hotel `languageId` onto a supported `language-region` code.
 * Missing values stay unset. Unsupported values such as `zh` fall back to `en-gb`.
 */
export const resolveSupportedHotelLanguageId = (
  languageId?: string | null,
): string | undefined => {
  const normalized = languageId?.trim().toLowerCase() ?? '';

  if (!normalized) {
    return undefined;
  }

  return isLanguageSupported(normalized)
    ? normalized
    : FALLBACK_HOTEL_LANGUAGE_ID;
};
